import { hexToRgb } from '/src/utils/hexToRgb';
import "./ConversationMarker.css";
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
const ConversationMarker = ({ marker, mode, className, style, onClick, icon }) => {

    var color = hexToRgb(marker.color);
    return (
        <div id={marker.id} style={style} className={className} >
            {
                mode != 1 &&
                <div style={{ background: `rgba(${color}, 0.9)` }} className="marker_conversation_circle conversation_bubble_marker" title={marker.name} />
            }
            {
                mode == 1 &&
                <div id={marker.id} className="marker_conversation_inline_main_container" title={marker.name}>
                    <div className='marker_conversation_inline_block_container'>
                        <div style={{ background: `rgba(${color}, 0.9)`, marginRight: "0" }} className="marker_conversation_circle conversation_bubble_marker" title={marker.name} />
                        <span className='marker_conversation_inline_text'>{marker.name}</span>
                        {
                            icon != "" ?
                                <IconButton className="main-iconButton modalButtons-input icon_marker_conversation" icon={icon} onClick={onClick} />
                                :
                                <div style={{ height: "42px", width: "45px" }}></div>
                        }


                    </div>
                </div>
            }
        </div>


        /*
        { 
        mode == 1 &&
        <span className='conversation_bubble_marker_text' style={{ color: marker.color }}>{marker.name}</span>
        }
        */

    )
};

/**
        <div id={marker.id} >
                <div style={{ background: `rgba(${color}, 0.1)`, border: `solid 1px ${marker.color}`, cursor: "default" }} className='conversation_bubble_marker'>
                    <span className='conversation_bubble_marker_text' style={{ color: marker.color }}>{marker.name}</span>
                </div>
            </div>

            * */

export default ConversationMarker;